export const topItemReducer = (state = false, action) => {
  switch (action.type) {
    case "TOGGLE_TOP_ITEM":
      return action.value;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/salesLoader/topItemsReducer.js